import { TemplateRef, ViewChild } from "@angular/core";
import { TemplateModel } from "@fs/models/template.model";
import { Subject } from "rxjs";

export abstract class WoBaseComponent {
  @ViewChild('tab1') tab1Ref: TemplateRef<any>;
  @ViewChild('tab2') tab2Ref: TemplateRef<any>;
  @ViewChild('tab3') tab3Ref: TemplateRef<any>;

  itemSearchTerm$ = new Subject<string>();
  subTabs:TemplateModel[] = [];

  protected readonly ngUnsubscribe$ = new Subject();

  protected initSubTabs() {
    this.subTabs.push(new TemplateModel(0, 'Work Order Information', this.tab1Ref, true));
    this.subTabs.push(new TemplateModel(1, 'Work Order Details', this.tab2Ref, false));
    this.subTabs.push(new TemplateModel(2, 'Total', this.tab3Ref, false));
  }
  
}